import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { TablepagedComponent, ColumnDef } from '../../../containers/table/tablepaged/tablepaged.component';
import {  FormAddConfig } from "../../../containers/form/formadd/formadd.component";
import {  FormUpdateConfig } from "../../../containers/form/formupdate/formupdate.component";
import { UpdateAddTableComponent, AttributeDefinition } from "../../basic/update-add-table/update-add-table.component";


@Component({
  selector: 'app-role',
  imports: [UpdateAddTableComponent],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss',
})
export class RoleComponent {
title = 'Auth roles';
description = "This are the roles of the App";
path = "/auth/role";
showFormAdd = true
element_name="role";
showUpdateButton = true;
showDeleteButton = true;

config: Array<AttributeDefinition> = [
{ title: 'Id',               store_key: 'Id' },
{ title: 'IdUserCreation',   store_key: 'IdUserCreation', hidden: true},
{ title: 'TimeCreation',     store_key: 'TimeCreation' , hidden: true},
{ title: 'Name',             store_key: 'Name' },
{ title: 'Description',      store_key: 'Description' }
];

@ViewChild(TablepagedComponent) table!: TablepagedComponent;

}
